import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface ContributionDonutChartProps {
    percentage: number;
    totalFindings: number;
    timesAboveAverage: number;
}

const ContributionDonutChart = ({ percentage, totalFindings, timesAboveAverage }: ContributionDonutChartProps) => {
    const data = [
        { name: 'Researcher', value: percentage },
        { name: 'Others', value: 100 - percentage }
    ];

    const COLORS = ['#010D2C', '#E5E7EB']; // Dark navy for researcher, light gray for others

    return (
        <div className="flex flex-col items-center w-full">
            {/* Donut Chart */}
            <div className="relative w-80 h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={95}
                            outerRadius={125}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>

                {/* Center Text */}
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <div className="text-3xl font-bold text-[#58CC02]">{percentage}%</div>
                    <div className="text-[10px] font-[500] text-[#010D2C] mt-0.5">of platform</div>
                </div>
            </div>

            {/* Explanation Text */}
            <div className="mt-6 w-full text-center px-4">
                <p className="text-sm text-[#6B7280] leading-relaxed">
                    This researcher has contributed <span className="font-semibold text-[#010D2C]">{percentage}%</span> of all security findings on the platform, demonstrating consistent engagement and expertise in identifying vulnerabilities.
                </p>
            </div>

            {/* Stats Below Chart */}
            <div className="mt-4 w-full flex justify-center">
                <div className="px-6 py-3 bg-[#E8FFF3] rounded-lg border border-[#BBF7D0]">
                    <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-[#58CC02]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-sm font-[500] text-[#58CC02]">
                            Amongst the top contributors
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContributionDonutChart;
